import { Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NAVIGATE_ROUTES } from '../../global/constants';
@Injectable({
    providedIn: 'root',
})
export class SignUpVerification {
    apiUrl: string = environment.url;
    apiEndPoint = NAVIGATE_ROUTES;
    responseData: any[] = [];
    constructor(private http: HttpClient) {}
    async verification(token: string): Promise<Observable<any>> {
        this.http
            .post<any>(this.apiUrl + this.apiEndPoint.SIGN_UP_VERIFICATION, {
                token: token,
            })
            .subscribe({
                next: (data) => {
                    this.responseData.push(data);
                },
                error: () => {
                    this.responseData.length = 0;
                },
            });
        return of(this.responseData).pipe(delay(1000));
    }
}
